module.exports = __webpack_public_path__ + "static/media/img79_R.699c5bbc.jpg";